import { useContext } from 'react'
import Input from '@talkdesk/cobalt-react-input'
import Button from '@talkdesk/cobalt-react-button'
import Label from '@talkdesk/cobalt-react-label'
import Box from '@talkdesk/cobalt-react-box'
import MFAHeader from '../../components/MFAHeader'
import ErrorMessage from '../../components/ErrorMessage'
import useMFA from '../../hooks/useMFA'
import { LoginContext } from '../../contexts/Login'
import {
  RECOVERY_CODE,
  RECOVERY_CODE_DESCRIPTION,
  INVALID_RECOVERY_OTP_ERROR_MESSAGE,
  GENERIC_RECOVERY_OTP_ERROR_MESSAGE,
  VERIFY
} from '../../constants/ui.labels'
import { RECOVERY_OTP } from '../../constants/mfa.types'

export const RecoveryOTP = ({ csrf, ctx, redirect }) => {
  const {
    code,
    showError,
    verifyButtonState,
    disabledForm,
    errorMessage,
    isVerifyButtonDisabled,
    handleCodeChange,
    doLogin
  } = useMFA({
    redirect,
    invalidCodeErrorMessage: () => INVALID_RECOVERY_OTP_ERROR_MESSAGE,
    genericErrorMessage: () => GENERIC_RECOVERY_OTP_ERROR_MESSAGE
  })

  const handleSubmit = () => {
    const mfa = {
      type: RECOVERY_OTP,
      payload: {
        otp: code
      }
    }
    doLogin(csrf, ctx.credentials, mfa)
  }

  return (
    <>
      <MFAHeader
        icon="vpn_key"
        iconColor="orange600"
        title={RECOVERY_CODE}
        subtitle={RECOVERY_CODE_DESCRIPTION}
      />
      <form
        onSubmit={e => {
          e.preventDefault()
          handleSubmit()
        }}
      >
        {showError ? <ErrorMessage message={errorMessage} /> : null}
        <div>
          <Label htmlFor="recovery-code">{RECOVERY_CODE}</Label>
          <Box paddingTop={2} />
          <Input
            id="recovery-code"
            autoFocus
            value={code}
            onChange={handleCodeChange}
            placeholder={RECOVERY_CODE}
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            disabled={disabledForm}
          />
        </div>
        <Box paddingTop={4} />
        <Button
          htmlType="submit"
          disabled={isVerifyButtonDisabled()}
          state={verifyButtonState}
          type="primary"
          shape="full-width"
        >
          {VERIFY}
        </Button>
      </form>
    </>
  )
}

const RecoveryOTPWithContext = props => {
  const ctx = useContext(LoginContext)
  return <RecoveryOTP ctx={ctx} {...props} />
}
RecoveryOTPWithContext.displayName = 'RecoveryOTP'

export default RecoveryOTPWithContext
